module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"SectionTemplates","button":"Add a sectionTemplate"}}')
  delete Component.options._Ctor
}
